import { render, staticRenderFns } from "./FloatingContact.vue?vue&type=template&id=37f6f133&scoped=true"
import script from "./FloatingContact.vue?vue&type=script&lang=js"
export * from "./FloatingContact.vue?vue&type=script&lang=js"
import style0 from "./FloatingContact.vue?vue&type=style&index=0&id=37f6f133&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f6f133",
  null
  
)

export default component.exports